const blogData = [
  {
    id: 1,
    title: "Embrace Nature's Beauty: Creating Your Own Terrarium",
    paragraph: (
      <>
        In today's fast-paced world, finding moments of tranquility and
        connection with nature is essential for our well-being. One wonderful
        way to bring a piece of the outdoors into your home or office is by
        creating your own terrarium. Terrariums are captivating miniature
        ecosystems that not only add a touch of green to your surroundings but
        also provide a sense of peace and serenity. Join me on this inspiring
        journey as we explore the art of crafting your very own terrarium.
        <br />
        <br />
        <strong className="heading1">
          Selecting the Perfect Container:
        </strong>{" "}
        <br />
        The first step in creating a terrarium is choosing the right container.
        Look for glass containers with an open top, such as jars, vases, or even
        fish tanks. Get creative and select a container that reflects your
        personal style and complements your living space. Remember, transparency
        is key to allowing sunlight to reach the plants within.
        <br />
        <br />
        <strong className="heading1">Gathering the Essentials:</strong> <br />
        To create a thriving terrarium, you will need a few essential supplies.
        These include:
        <ul>
          <li>
            a. Pebbles or small rocks: These act as a drainage layer at the
            bottom of your terrarium, preventing waterlogging and promoting
            healthy root growth.
          </li>
          <li>
            b. Activated charcoal: Charcoal helps filter the air within the
            terrarium and prevents any unpleasant odors caused by excess
            moisture.
          </li>
          <li>
            c. Potting soil: Choose a well-draining soil mix suitable for indoor
            plants. Avoid using garden soil, as it may retain too much moisture.
          </li>
          <li>
            d. Assorted plants: Opt for small plants that thrive in humid
            environments and have similar light and water requirements. Popular
            choices include ferns, mosses, succulents, and air plants.
          </li>
          <li>
            e. Decorative elements (optional): Add a touch of personal flair
            with decorative items like small figurines, pebbles, or pieces of
            driftwood. Let your imagination guide you.
          </li>
        </ul>
        <br />
        <br />
        <strong className="heading1">Building the Layers:</strong> <br />
        Now comes the fun part – creating layers within your terrarium. Follow
        these steps:
        <ul>
          <li>
            a. Start with a 1-2 inch layer of pebbles at the bottom to promote
            drainage.
          </li>
          <li>
            b. Add a thin layer of activated charcoal to keep the terrarium
            fresh and odor-free.
          </li>
          <li>
            c. Carefully add the potting soil, leaving enough space for your
            plants to be comfortably nestled.
          </li>
        </ul>
        <br />
        <br />
        <strong className="heading1">Planting and Arranging:</strong> <br />
        The arrangement of your plants is key to the visual appeal of your
        terrarium. Consider the varying heights, colors, and textures of the
        plants for an eye-catching display. Gently remove the plants from their
        containers, loosen the roots, and plant them in the soil. Create a
        harmonious composition by placing taller plants at the back and smaller
        ones toward the front. Feel free to rearrange until you achieve your
        desired look.
        <br />
        <br />
        <strong className="heading1">Caring for Your Terrarium:</strong> <br />
        Caring for your terrarium is simple but crucial. Place it in a location
        with bright, indirect light to ensure the plants thrive. Avoid direct
        sunlight, as it can lead to excessive heat and scorch the delicate
        plants. Water sparingly, allowing the soil to dry out between watering
        sessions. Mist the plants occasionally to maintain humidity within the
        terrarium. Remember to observe and adapt your care routine based on the
        specific needs of your plants.
        <br />
        <br />
        <strong className="heading1">
          Embracing the Beauty of Nature
        </strong>{" "}
        <br />
        Creating your own terrarium is not only an enjoyable and fulfilling
        experience but also a rewarding way to invite the beauty of nature into
        your everyday life. As you watch your tiny ecosystem flourish and grow,
        you'll find yourself captivated by its charm and serenity. So, let your
        creativity blossom and embark on the journey of crafting your very own
        terrarium. Embrace the wonders of nature, and let it inspire you to
        create beauty wherever you go.
      </>
    ),
    image:
      "https://images.unsplash.com/photo-1417037129170-06a2750eaa47?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",

    tags: ["creative"],
    publishDate: "14/March/2023",
  },
  {
    id: 2,
    title: "Mental Health: It's Time to Break the Stigma",
    paragraph: (
      <>
        Mental health is a topic that many people tend to avoid or overlook, but
        it's time to break the stigma and start talking about it. Mental health
        affects everyone, regardless of age, gender, or social status. It's not
        something that should be hidden or ignored, as it can have a profound
        impact on our lives and the lives of those around us.
        <br />
        <br />
        When we talk about mental health, we often think about conditions like
        depression and anxiety. While these are certainly important aspects of
        mental health, it's important to remember that mental health encompasses
        a wide range of issues, including trauma, addiction, eating disorders,
        and more.
        <br />
        <br />
        One of the biggest challenges we face when it comes to mental health is
        the stigma that surrounds it. Many people are reluctant to seek help or
        talk about their struggles because they fear being judged or
        misunderstood. This can lead to feelings of isolation and shame, which
        can only make things worse.
        <br />
        <br />
        But here's the thing: mental health is just as important as physical
        health. It's not a weakness or a flaw, and it's not something that can
        be simply "fixed" with a positive attitude or a stiff upper lip. It
        requires compassion, understanding, and support.
        <br />
        <br />
        If you're struggling with your mental health, know that you're not
        alone. There are resources available to you, including therapy, support
        groups, and hotlines. And if you're worried about someone else, reach
        out to them with kindness and empathy. Let them know that you care and
        that you're there for them.
        <br />
        <br />
        We all have a role to play in breaking the stigma surrounding mental
        health. By being open and honest about our struggles, we can help create
        a culture of acceptance and understanding. Let's start talking, and
        let's start healing.
        <br />
        <br />
        <strong className="tags">
          {" "}
          #people #mentalhealth #trauma #health #culture #empathy
        </strong>
      </>
    ),
    image:
      "https://images.unsplash.com/photo-1564121211835-e88c852648ab?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    tags: ["mental health"],
    publishDate: "02/May/2023",
  },
  {
    id: 3,
    title: "Tips to quickly improve your coding speed.",
    paragraph: (
      <>
        In the world of coding, where every keystroke matters, speed and
        efficiency are paramount. While coding proficiency encompasses various
        skills, one often overlooked aspect is typing speed. Many developers
        underestimate the impact that faster typing can have on their
        productivity and overall coding experience. In this article, we will
        delve into the importance of typing faster and how it can significantly
        enhance your coding journey.
        <br />
        <br />
        <strong className="heading1">Increased Efficiency and Workflow</strong>
        <br />
        As a programmer, your keyboard is your primary tool for translating
        ideas into lines of code. The ability to type quickly and accurately
        means you can swiftly transcribe your thoughts, reducing the time spent
        on mundane typing tasks. Faster typing enables you to keep up with the
        pace of your thoughts, preventing mental interruptions and allowing you
        to maintain a steady workflow. By minimizing the lag between thinking
        and typing, you can stay focused and immersed in the coding process.
        <br />
        <br />
        <strong className="heading1">Time Savings</strong>
        <br />
        Coding projects often come with tight deadlines and demanding schedules.
        Every minute counts, and even small time savings can add up
        significantly over time. Improving your typing speed directly translates
        to time saved during coding sessions. Tasks such as writing code
        snippets, debugging, and making edits become more efficient, allowing
        you to accomplish more within the same timeframe. Ultimately, this gives
        you a competitive edge, enabling you to deliver projects faster and meet
        deadlines with ease.
        <br />
        <br />
        <strong className="heading1">Reduced Typos and Errors</strong>
        <br />
        Coding requires precision and attention to detail. Faster typing,
        coupled with accuracy, helps reduce the occurrence of typos and syntax
        errors. When you type quickly and confidently, you can concentrate on
        the logic and structure of your code, rather than getting caught up in
        correcting mistakes. With fewer errors, you'll spend less time
        troubleshooting and debugging, enabling you to focus on higher-level
        problem-solving and creating clean, reliable code.
        <br />
        <br />
        <strong className="heading1">Improved Focus and Concentration</strong>
        <br />
        Slow typing can disrupt your concentration and break the flow of your
        thoughts. It's like having a conversation that constantly gets
        interrupted, hindering your ability to stay in the coding zone. On the
        other hand, faster typing enables you to maintain a smooth rhythm,
        eliminating distractions and allowing you to dive deep into the coding
        process. By honing your typing speed, you can foster a state of flow,
        where ideas seamlessly transform into lines of code, leading to
        increased productivity and creativity.
        <br />
        <br />
        <strong className="heading1">Better Collaboration</strong>
        <br />
        In today's collaborative coding environments, the ability to type
        quickly is essential for effective teamwork. Pair programming, code
        reviews, and collaborative projects often require real-time
        communication and code updates. Fast typing skills enable you to keep up
        with discussions, contribute efficiently, and seamlessly collaborate
        with team members. Additionally, when participating in coding
        competitions or hackathons, faster typing can give you a competitive
        advantage, enabling you to implement ideas rapidly and demonstrate your
        coding prowess.
        <br />
        <br />
        <strong className="heading1">Conclusion</strong>
        <br />
        Don't underestimate the power of fast and accurate typing in the world
        of coding. Developing your typing speed and proficiency is an investment
        that pays off in enhanced productivity, time savings, reduced errors,
        improved focus, and better collaboration. Embrace the practice of touch
        typing, utilize typing speed improvement tools, and make it a priority
        to continuously refine your typing skills. By mastering the art of fast
        typing, you'll not only become a more efficient coder but also unlock
        new levels of creativity and productivity in your coding journey.
      </>
    ),
    image:
      "https://images.unsplash.com/photo-1673348094802-aebab25be499?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",

    tags: ["productivity"],
    publishDate: "01/Jan/2023",
  },
  {
    id: 4,
    title: "Roadmap: A Guide for Full Stack Developers",
    paragraph: (
      <>
        Becoming a skilled full stack developer requires a comprehensive
        understanding of both front-end and back-end web development. With the
        ever-evolving nature of the field, it's crucial to have a roadmap that
        outlines the key skills, technologies, and concepts you need to master.
        In this article, we'll provide you with a clear and practical web
        development roadmap to help you embark on your journey to becoming a
        proficient full stack developer. <br /> <br />
        <strong className="heading2">
          Mastering Front-End Fundamentals
        </strong>{" "}
        <br />
        Start your journey by mastering the fundamental building blocks of
        front-end development. This includes HTML, CSS, and JavaScript. Learn
        how to structure web pages with HTML, style them with CSS, and add
        interactivity using JavaScript. Familiarize yourself with concepts like
        responsive design, accessibility, and cross-browser compatibility.{" "}
        <br /> <br />
        <strong className="heading2">
          Delving into JavaScript Frameworks
        </strong>{" "}
        <br />
        To develop dynamic and interactive user interfaces, dive into popular
        JavaScript frameworks like React, Angular, or Vue.js. Learn how to
        leverage these frameworks to build reusable components, manage state,
        and handle data flow within your applications. Gain hands-on experience
        in building single-page applications (SPAs) and understanding concepts
        like virtual DOM, component-based architecture, and state management.
        <br /> <br />
        <strong className="heading2">Back-End Development</strong> <br />
        Transition to the server-side by delving into back-end development.
        Choose a server-side language such as JavaScript (Node.js), Python,
        Ruby, or PHP, and explore its frameworks and libraries. Learn about
        server architecture, RESTful APIs, database management systems (e.g.,
        SQL and NoSQL), and authentication/authorization mechanisms. Build
        server-side applications, learn about routing, handle HTTP requests, and
        work with databases.
        <br /> <br />
        <strong className="heading2">Databases and Data Management</strong>{" "}
        <br />
        Dive deeper into the realm of databases by understanding concepts like
        data modeling, querying, and optimization. Familiarize yourself with
        both relational databases (e.g., MySQL, PostgreSQL) and NoSQL databases
        (e.g., MongoDB, Redis). Learn how to interact with databases through
        Object-Relational Mapping (ORM) libraries or query languages like SQL.
        Gain insights into data caching, indexing, and handling large datasets
        efficiently.
        <br /> <br />
        <strong className="heading2">
          {" "}
          Learning Web Servers and Deployment
        </strong>{" "}
        <br />
        Understand the underlying infrastructure that powers web applications.
        Learn about web servers like Apache or Nginx, and gain knowledge about
        server management, hosting environments, and deployment strategies.
        Explore cloud platforms like AWS, Azure, or Google Cloud to deploy your
        applications and configure scalable and secure server environments.
        <br /> <br />
        <strong className="heading2">
          Version Control and Collaboration
        </strong>{" "}
        <br />
        Proficiency in version control systems, particularly Git, is vital for
        collaboration and project management. Learn essential Git commands,
        understand branching strategies, and explore platforms like GitHub or
        GitLab for collaboration and code review. Familiarize yourself with
        agile development methodologies, issue tracking, and project management
        tools.
        <br />
        <br />
        <strong className="heading2">
          Continuous Learning and Keeping Up with Trends
        </strong>{" "}
        <br />
        Web development is a constantly evolving field. Stay updated with the
        latest technologies, frameworks, and best practices. Engage in online
        communities, attend conferences, and participate in open-source
        projects. Embrace continuous learning and explore emerging trends like
        Progressive Web Apps (PWAs), serverless architecture, microservices, and
        DevOps practices.
        <br />
        <br />
        If you would like to have a detail version of how to become a full stack
        web developer this is a website that could help you out.
        <br />{" "}
        <a
          href="https://roadmap.sh/"
          className="link"
          target="_blank"
          rel="noreferrer"
        >
          Click here
        </a>
      </>
    ),
    image:
      "https://images.unsplash.com/photo-1640282693834-f941c0c012aa?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    tags: ["technology", "guide"],
    publishDate: "10/Oct/2020",
  },
  {
    id: 5,
    title:
      "The Pursuit of Happiness: Unveiling the Secrets to a Fulfilling Life",
    paragraph: (
      <>
        Happiness is something we all seek, but it's more than just fleeting
        moments of joy. It's a deep sense of well-being, contentment, and
        meaning in life. To cultivate happiness, we need to adopt positive
        mindsets like gratitude and resilience. By appreciating the present
        moment and embracing challenges as opportunities for growth, we can
        shift our perspective and create a foundation for lasting happiness.
        <br />
        <br />
        Building meaningful relationships is crucial for our happiness.
        Connecting with loved ones and engaging in acts of kindness brings a
        sense of belonging and emotional fulfillment. It's also important to
        pursue personal growth and find purpose in our lives. By aligning our
        activities with our values and passions, setting meaningful goals, and
        embracing new experiences, we can unlock our potential and make a
        meaningful impact.
        <br />
        <br />
        Taking care of ourselves through self-care and mindfulness is essential.
        Engaging in activities that promote relaxation, self-reflection, and
        self-compassion, such as meditation and hobbies, helps us maintain a
        healthy balance. Practicing gratitude is a powerful tool that shifts our
        focus to the positive aspects of our lives and cultivates contentment.
        <br />
        <br />
        Finding a work-life balance is vital. Prioritizing leisure, quality time
        with loved ones, and setting boundaries at work prevent burnout and
        contribute to our overall happiness. Remember, happiness is a lifelong
        journey, unique to each individual. By incorporating these principles
        into our lives, we can navigate the path to happiness with greater
        clarity and fulfillment.
      </>
    ),
    image:
      "https://images.unsplash.com/photo-1489710437720-ebb67ec84dd2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",

    tags: ["self improvement"],
    publishDate: "20/05/2023",
  },
  {
    id: 6,
    title: "From Fear to Triumph: Embracing Evolution's Unlikely Ally",
    paragraph: (
      <>
        Fear is an intrinsic human emotion that has played a pivotal role in our
        survival and evolution throughout history. From our early ancestors
        facing life-threatening predators to modern-day challenges, fear has
        shaped our behavior and influenced the trajectory of our species. In
        this blog, we will explore the complex relationship between fear and
        evolution, delving into how fear has both hindered and propelled our
        progress as a society.
        <br />
        <br />
        <strong className="heading1">
          Fear as an Evolutionary Survival Mechanism:
        </strong>{" "}
        <br />
        <br />
        Fear evolved as a crucial survival mechanism, enabling our ancestors to
        recognize and respond to potential threats in their environment. It
        served as an instinctual alarm system, triggering the fight-or-flight
        response, which allowed our predecessors to effectively navigate
        dangerous situations. Those who possessed a healthy level of fear were
        more likely to survive and pass on their genes, leading to the
        perpetuation of fear as a fundamental human trait.
        <br />
        <br />
        <strong className="heading1">
          Fear as a Catalyst for Progress:
        </strong>{" "}
        <br />
        <br />
        While fear is often associated with negative connotations, it has also
        served as a powerful motivator throughout history. Fear of the unknown,
        fear of failure, and fear of being left behind have driven individuals
        and societies to push beyond their comfort zones, explore uncharted
        territories, and achieve remarkable advancements. <br />
        <br />
        <strong className="heading1"> Innovation and Fear:</strong>
        <br />
        <br />
        Innovation and progress often emerge in response to societal fears and
        challenges. Consider the fear of disease and the subsequent development
        of modern medicine, or the fear of famine leading to advancements in
        agriculture. Fear has compelled humans to seek solutions and find ways
        to overcome obstacles, propelling us forward in countless fields.
        <br />
        <br />
        <strong className="heading1"> Social Progress and Fear:</strong>
        <br />
        <br />
        Fear has not only influenced technological and scientific progress but
        has also played a significant role in shaping our social structures.
        Fear of social exclusion and ostracism has led to the establishment of
        norms, ethics, and governance systems, fostering cooperation and
        creating cohesive societies. Fear of inequality and injustice has
        sparked social movements and struggles for equality, leading to
        significant societal advancements. <br />
        <br />
        <strong className="heading1">
          {" "}
          Fear and the Dark Side of Progress:
        </strong>{" "}
        <br />
        <br />
        While fear has propelled us forward, it also has a darker side that can
        impede progress. Fear of change, fear of the unknown, and fear of losing
        power or control have hindered social and scientific advancements
        throughout history. Resistance to new ideas and perspectives has often
        stemmed from a place of fear, stifling innovation and limiting our
        collective potential. <br />
        <br />
        <strong className="heading1">
          {" "}
          Managing Fear in the Modern World:
        </strong>
        <br />
        <br />
        In today's rapidly evolving world, fear takes on new forms. The advent
        of technology has introduced unprecedented challenges and fears related
        to privacy, artificial intelligence, and the changing job market. It is
        essential to acknowledge and manage these fears effectively to ensure
        that progress continues unabated. <br />
        <br />
        <strong className="heading1">Conclusion:</strong>
        <br />
        <br />
        Fear and evolution are intricately linked, with fear both hindering and
        propelling our progress as a society. While fear has undoubtedly played
        a crucial role in our survival and development, it is vital to recognize
        its potential to impede progress when left unchecked. By embracing a
        healthy level of fear and effectively managing it, we can harness its
        power as a catalyst for growth, innovation, and positive societal
        change. Ultimately, understanding the role fear plays in our lives
        enables us to navigate the challenges of our ever-evolving world and
        shape a better future for ourselves and generations to come
        <br />
        <br />
        <strong className="tags">
          {" "}
          #people #mentalhealth #trauma #health #culture #empathy
        </strong>
      </>
    ),
    image:
      "https://images.unsplash.com/photo-1618989553444-5f3cd080356f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80",

    tags: ["mental health"],
    publishDate: "17/05/2023",
  },
  {
    id: 7,
    title: "The Thousand Splendid Suns- My All Time Favorite Book",
    paragraph: (
      <>
        The Thousand Splendid Suns" by Khaled Hosseini is my favorite book, a
        powerful and emotionally resonant tale that takes us on a journey
        through the lives of two women in war-torn Afghanistan. Hosseini's
        captivating storytelling transports us into the lives of Mariam and
        Laila, two vastly different women brought together by fate and bonded by
        their resilience, love, and shared experiences. Through their eyes, we
        witness the struggles, sacrifices, and resilience of Afghan women in a
        society plagued by violence, oppression, and inequality. The book
        beautifully captures the complexity of human relationships, the strength
        of the human spirit, and the power of hope in the face of adversity. It
        is a poignant and thought-provoking novel that shines a light on the
        untold stories of women and their indomitable spirit in the midst of a
        harsh and unforgiving world. "The Thousand Splendid Suns" is a
        masterpiece that left a lasting impact on me, reminding me of the
        indescribable strength that resides within individuals, even in the
        darkest of times.
      </>
    ),
    image:
      "https://images.unsplash.com/photo-1590457429592-1abd191ad4c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1169&q=80",

    tags: ["books"],
    publishDate: "20/05/2023",
  },
  {
    id: 8,
    title: "How Discipline Transformed My Life: A Personal Journey",
    paragraph: (
      <>
        Everyone has a turning point in their life when they realize they need
        to make a change. For me, that moment came when I recognized the lack of
        structure and direction in my life. It was then that I decided to
        embrace discipline, and little did I know that this decision would
        completely transform my life.
        <br />
        <br />
        <strong className="heading2">Chapter 1: The Awakening</strong> <br />
        <br />
        I was living a chaotic and aimless life, constantly jumping from one
        thing to another without any real purpose. I lacked focus and direction,
        and it affected every aspect of my life. One day, I stumbled upon a book
        that spoke about the power of discipline in shaping one's destiny.
        Intrigued, I decided to give it a chance and began my journey towards
        change.
        <br />
        <br />
        <strong className="heading2">
          Chapter 2: Setting Clear Goals
        </strong>{" "}
        <br />
        <br />
        As I delved deeper into the realm of discipline, I realized that setting
        clear goals was essential. I started by identifying my passions, dreams,
        and aspirations. With discipline as my guiding light, I created a
        roadmap for my life. I set both short-term and long-term goals, each
        with a clear purpose and timeline. <br />
        <br />
        <strong className="heading2">
          Chapter 3: Embracing Productive Habits
        </strong>
        <br />
        <br />
        Discipline taught me that success is not a stroke of luck but a result
        of consistent effort and habits. I knew I needed to establish productive
        routines that would support my goals. I started by incorporating small
        but significant changes into my daily life. Waking up early became a
        non-negotiable habit, allowing me to seize the day with purpose. I
        dedicated time for exercise, learning, and personal growth, realizing
        that discipline is not just about achieving external goals but also
        nurturing the mind and body.
        <br />
        <br />
        <strong className="heading2"> Chapter 4: Overcoming Challenges</strong>
        <br />
        <br />
        Discipline empowered me to face challenges head-on. It taught me
        resilience and the importance of perseverance. Instead of giving up when
        faced with obstacles, I learned to stay committed and find alternative
        solutions. Discipline provided me with the mental strength to push
        through difficult times, knowing that every setback was an opportunity
        for growth.. <br />
        <br />
        <strong className="heading2">
          {" "}
          Chapter 5: Celebrating Victories
        </strong>{" "}
        <br />
        As I remained disciplined and focused, I started achieving small
        victories along the way. Each milestone reached reinforced my belief in
        the power of discipline. Whether it was accomplishing a personal goal,
        excelling in my career, or nurturing meaningful relationships,
        discipline had become the driving force behind my success.. <br />
        <br />
        <strong className="heading2">Conclusion:</strong>
        <br />
        <br />
        Discipline has truly transformed my life. It has given me purpose,
        focus, and the determination to pursue my dreams. Through setting clear
        goals, embracing productive habits, overcoming challenges, and
        celebrating victories, I have witnessed the remarkable impact of
        discipline on my personal growth and achievements. I encourage everyone
        to embrace discipline and unlock their full potential, for it is through
        discipline that we truly shape our destinies.
        <br />
        <br />
        <strong className="tags">
          {" "}
          #fear #evolution #survival #progress #motivation #innovation #challenges #societaladvancements #change #technology #future #growth #society #positivechange #mentalhealth #trauma #health #culture #empathy
        </strong>
      </>
    ),
    image:
      "https://images.unsplash.com/photo-1616157780923-13a1177ef6c5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1191&q=80",

    tags: ["self improvement"],
    publishDate: "21/05/2023",
  },
];
export default blogData;
